"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipFileSeasonState = void 0;
var ZipFileSeasonState;
(function (ZipFileSeasonState) {
    ZipFileSeasonState["GeneratingParticipantsBySeasonZip"] = "generatingParticipantsBySeasonZip";
    ZipFileSeasonState["DeletingParticipantsBySeasonZip"] = "deletingParticipantsBySeasonZip";
})(ZipFileSeasonState = exports.ZipFileSeasonState || (exports.ZipFileSeasonState = {}));
//# sourceMappingURL=zip-file-season-state.js.map